import React, { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setActivityDeleteModal,
  setActivityDeletePath,
} from "../Store/ui/modals";
const DeleteModal = () => {
  const { activityDeleteModal } = useSelector((state) => state.ui.modals);
  const dispach = useDispatch();
  return (
    <Fragment>
      <div
        className={`modal fade show`}
        style={{ display: `${activityDeleteModal.isOpen ? "block" : "none"}` }}
        id="exampleModalCenter"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                Modal title
              </h5>
              <a
                className="close cursor"
                data-dismiss="modal"
                aria-label="Close"
                onClick={(e) => {
                  e.stopPropagation();
                  dispach(setActivityDeleteModal(false));
                }}
              >
                <span aria-hidden="true">&times;</span>
              </a>
            </div>
            <div className="modal-body">
              Are you sure you want to delete this activity?
            </div>
            <div className="modal-footer">
              <button
                className="btn_black_theme w-100"
                onClick={(e) => {
                  e.stopPropagation();
                  dispach(setActivityDeleteModal(false));
                }}
              >
                No
              </button>
              <button type="button" className="btn_black_theme w-100">
                DELETE
              </button>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default DeleteModal;
